var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "mt-5" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "8", lg: "6" } },
            [
              _vm.showTable
                ? _c(
                    "b-button",
                    {
                      staticClass: "mb-3",
                      attrs: { variant: "primary", block: "" },
                      on: { click: _vm.back },
                    },
                    [_vm._v(" Back ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          !_vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "8", lg: "6" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: {
                        header: "Select Date Range",
                        "header-tag": "h4",
                      },
                    },
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Date From",
                                "label-for": "date-from",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "date-from",
                                  placeholder: "Select start date",
                                  max: _vm.dateTo,
                                },
                                model: {
                                  value: _vm.dateFrom,
                                  callback: function ($$v) {
                                    _vm.dateFrom = $$v
                                  },
                                  expression: "dateFrom",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Date To",
                                "label-for": "date-to",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "date-to",
                                  placeholder: "Select end date",
                                  min: _vm.dateFrom,
                                },
                                model: {
                                  value: _vm.dateTo,
                                  callback: function ($$v) {
                                    _vm.dateTo = $$v
                                  },
                                  expression: "dateTo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.submitDates },
                            },
                            [_vm._v(" Submit ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: { header: _vm.tdsHeader, "header-tag": "h4" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: { variant: "success" },
                          on: { click: _vm.exportToCSV },
                        },
                        [_vm._v(" Export to CSV ")]
                      ),
                      _c(
                        "b-table",
                        {
                          attrs: {
                            striped: "",
                            hover: "",
                            responsive: "sm",
                            items: _vm.formattedTableData,
                            fields: _vm.tableFields,
                          },
                        },
                        [
                          _vm._v(
                            ' :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @sort-changed="onSortChanged"> '
                          ),
                        ]
                      ),
                      _c(
                        "b-row",
                        { staticClass: "w-100" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mt-2", attrs: { cols: "6" } },
                            [
                              _c("h5", { staticClass: "text-uppercase" }, [
                                _vm._v("Total"),
                              ]),
                            ]
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "mt-xl-0 mt-2 d-flex justify-content-end",
                              attrs: { cols: "6" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "font-weight-bolder justify-content-end text-right",
                                },
                                [
                                  _c("hr", { staticClass: "my-50" }),
                                  _c("p", { staticClass: "card-text mb-25" }, [
                                    _vm._v(
                                      "Debit: " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            _vm.getTotalDebit
                                          )
                                        )
                                    ),
                                  ]),
                                  _c("p", { staticClass: "card-text mb-25" }, [
                                    _vm._v(
                                      "Credit: " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            _vm.getTotalCredit
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }